import type { CurrentUserResponse } from "@multi-chat/shared";

/** Patch one membership's effective name without re-bootstrapping auth. */
export function applyMemberDisplayNameToUser(
  user: CurrentUserResponse,
  organizationId: number,
  displayName: string,
): CurrentUserResponse {
  return {
    ...user,
    organizations: user.organizations.map((organization) =>
      organization.id === organizationId
        ? { ...organization, memberDisplayName: displayName }
        : organization,
    ),
  };
}
